import { Button } from "antd"
import { DeleteOutlined } from "@ant-design/icons"

const CartItem = ({ item, onRemove }) => {
  const firstImage = Array.isArray(item.images) && item.images.length > 0 ? item.images[0] : "/placeholder.svg"

  return (
    <div
      style={{
        marginBottom: "15px",
        padding: "10px",
        border: "1px solid #f0f0f0",
        borderRadius: "4px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={firstImage} alt={item.name} style={{ width: "60px", marginRight: "15px" }} />
          <div>
            <h4 style={{ margin: "0 0 5px 0", fontSize: "1em", fontWeight: "bold" }}>{item.name}</h4>
            <p style={{ margin: "0", fontSize: "0.9em", color: "#888" }}>Medida: {item.measure}</p>
            <p style={{ margin: "0", fontSize: "0.9em", color: "#888" }}>Cantidad: {item.quantity}</p>
          </div>
        </div>
        <div style={{ textAlign: "right" }}>
          <Button
            type="text"
            danger
            onClick={() => onRemove(item.id, item.measure)}
            icon={<DeleteOutlined />}
            style={{ marginTop: "5px" }}
          />
        </div>
      </div>
    </div>
  )
}

export default CartItem
